import { render, staticRenderFns } from "./CanBus.vue?vue&type=template&id=54654fc4&"
import script from "./CanBus.vue?vue&type=script&lang=js&"
export * from "./CanBus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports